import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {Card, CardText} from 'material-ui/Card';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Delete from 'material-ui/svg-icons/action/delete';
import ConfirmButton from 'material-ui-confirm-button';
import config from '../../config'
import moment from 'moment-timezone'

import {fetchTokens, closeTokensModal, fetchCompaniesForBuilding, closeTokenForm, deleteToken} from '../../actions/buildings'

const iconStyle = {
  margin: 0,
  padding: 0,
  minWidth: 0,
  width: 50,
};

class Tokens extends Component {

  static defaultProps = {
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
  }

  componentWillUpdate() {
    // if (this.props.selectedBuildingForTokens) {
    //   const { dispatch } = this.props
    //   dispatch(fetchTokens(this.props.selectedBuildingForTokens))
    // }
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeTokensModal())
  }

  showGenerateTokensForm() {
    const { dispatch } = this.props
    let selectedBuilding = this.props.selectedBuildingForTokens
    dispatch(fetchCompaniesForBuilding(selectedBuilding))
  }

  deleteToken(token) {
    const { dispatch } = this.props
    dispatch(deleteToken(token))
  }

  render() {
      const actions = [
        <FlatButton
          label="Close"
          primary={true}
          onClick={this.closeDialog.bind(this)}
        />,
        <FlatButton
          label="Generate Tokens"
          primary={true}
          onClick={this.showGenerateTokensForm.bind(this)}
        />,
      ];

      return (
        <Dialog
          actions={actions}
          title="Tokens"
          modal={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={true}
          repositionOnUpdate={true}
          contentStyle={{ width: "80%", maxWidth: "none", transform: "translate(0px, 0px)" }}
          open={this.props.selectedBuildingForTokens != null}>

            {(this.props.tokens && this.props.tokens.length > 0) ?
                (
                <div>
                  <Table selectable={false} style={{tableLayout: 'auto'}} fixedHeader={false}>
                      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                          <TableHeaderColumn style={{width: '1%'}}>ID</TableHeaderColumn>
                          <TableHeaderColumn style={{width: '1%'}}>Invitation Code</TableHeaderColumn>
                          <TableHeaderColumn style={{width: '6%'}}>Invitation URL</TableHeaderColumn>
                          <TableHeaderColumn style={{width: '3%'}}>Company</TableHeaderColumn>
                          <TableHeaderColumn style={{width: '3%'}}>User</TableHeaderColumn>
                          <TableHeaderColumn style={{width: '3%'}}></TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody displayRowCheckbox={false}>
                        {this.props.tokens.map((token, index) =>
                          <TableRow>
                            <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '1%'}}>{index + 1}</TableRowColumn>
                            <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '1%'}}>{token.token}</TableRowColumn>
                            <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '6%'}}><a href={config.web_url + '?invitation=' + token.token}>{config.web_url}?invitation={token.token}</a></TableRowColumn>
                            <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '3%'}}>{token.company.name}</TableRowColumn>
                            <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '3%'}}>{token.user ? token.user._id : "Not Used"}</TableRowColumn>
                            <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '3%'}}>
                              <ConfirmButton key={token._id} isFlat={true} style={iconStyle} icon={<Delete />} confirmMessage="	&#10004;" cancelMessage="X" secondary={true} onSubmit={this.deleteToken.bind(this, token)} />
                            </TableRowColumn>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                </div>
              )
              :
              (
                <Card style={{width: '100%', height: '100%'}}>
                <CardText style={{position: 'relative', width: '100%', height: '100%'}}>
                  No tokens were generated for this building
                </CardText>
              </Card>
              )
            }

        </Dialog>
      )
  }
}

const mapStateToProps = state => {
  return state.buildingsReducer
}

export default withRouter(
  connect(mapStateToProps)(Tokens)
);



// WEBPACK FOOTER //
// ./src/components/buildings/Tokens.js